const initialState = {
	records: []
};

const snb = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_SNB_DATA_SUCCESS':
			if (action.payload.page > 1) {
				action.payload.records =  state.records.concat(action.payload.records);
			}
			return Object.assign({},state,{ ...action.payload });
		case 'GET_SNB_DATA_FAILURE':
			return Object.assign({},state, { });
		case 'GET_SNB_FILTERS_SUCCESS':
			return Object.assign({},state,{ ...action.payload  });
		case 'GET_SNB_FILTERS_FAILURE':
			return Object.assign({},state,{ });
		case 'UPDATE_SNB_DATA':
			return Object.assign({},state,{ ...action.data });
		default:
			return state;
	}
};

export default snb;


// WEBPACK FOOTER //
// ../q-cars/src/redux/reducers/snb.js